function Generatelabel() {
  return <div>Generatelabel</div>;
}

export default Generatelabel;
